@import 'src/styles/common/_colors.scss';
.secondaryNav {
	// background: linear-gradient(to bottom,  #2e2f30 0%,#141414 100%);
	// background-color: $gray;
	  background: linear-gradient(180deg, #3D3F40 0%, #141414 100%);
	box-shadow: 0 1px 1px rgba($white, 0.35);
	line-height: 38px;
	/* z-index: 2; /* fix bottom shadow visibility */
	display: flex;
    justify-content: space-between;
    align-items: center;
	padding: 3px 8px;
	white-space:nowrap;
	flex-wrap: wrap;
	&.withBorder{
		border: 1px solid $black;
		background: linear-gradient(180deg,$smoke-black 0,$mightnight-black);
	}
	&.topBorder{
		border-top: 1px solid rgba($white, 0.35);
	}
	&.onlyCenterWrapper{
		justify-content: center;
		background: linear-gradient(180deg,$smoke-black 0,$mightnight-black);
	}
}

.leftWrapper{
    display: flex;
	align-items: center;
	gap:8px;
	line-height: 35px;
}

.rightWrapper{
    &.horizontal{
        display: flex;
        align-items: center;
        gap: 8px;
    }
}

.centerWrapper{
	display: flex;
	align-items: center;
}